// extracted by mini-css-extract-plugin
export default {"dropdown":"styles_dropdown__SavYn","header":"styles_header__B4wiv","userThumbnail":"styles_userThumbnail__QUrLI","dropdownMenu":"styles_dropdownMenu__klIwq"};